import React, { Component } from 'react'

export default class NavigationDesk extends Component {
    render() {
        return <div className={'linkages-navigation-desk'}>{'Linkages navigation sources desk'}</div>
    }
}
